import { defineIntegration, consoleSandbox } from '@sentry/core';
import { FAKE_FUNCTION } from './common.js';
import { DEBUG_BUILD } from './debug-build.js';

/**
 * This is a shim for the logger namespace.
 * It is needed in order for the CDN bundles to continue working when users add/remove logs
 * from it, without changing their config. This is necessary for the loader mechanism.
 */
function logShim(_message, _attributes) {
  DEBUG_BUILD &&
    consoleSandbox(() => {
      // eslint-disable-next-line no-console
      console.warn('You are using Sentry.logger.* even though this bundle does not include logs.');
    });
}

/**
 * This is a shim for the logger.fmt template literal function.
 * It is needed in order for the CDN bundles to continue working when users add/remove logs
 * from it, without changing their config. This is necessary for the loader mechanism.
 */
function fmtShim(_strings, ..._values) {
  DEBUG_BUILD &&
    consoleSandbox(() => {
      // eslint-disable-next-line no-console
      console.warn('You are using Sentry.logger.fmt even though this bundle does not include logs.');
    });
  return '' ;
}

const loggerShim = {
  trace: logShim,
  debug: logShim,
  info: logShim,
  warn: logShim,
  error: logShim,
  fatal: logShim,
  fmt: fmtShim,
};

/**
 * This is a shim for the consoleLoggingIntegration.
 * It is needed in order for the CDN bundles to continue working when users add/remove logs
 * from it, without changing their config. This is necessary for the loader mechanism.
 */
const consoleLoggingIntegrationShim = defineIntegration((_options) => {
  DEBUG_BUILD &&
    consoleSandbox(() => {
      // eslint-disable-next-line no-console
      console.warn('You are using consoleLoggingIntegration() even though this bundle does not include logs.');
    });

  return {
    name: 'ConsoleLogs',
    setup: FAKE_FUNCTION,
  };
}) ;

export { consoleLoggingIntegrationShim, loggerShim };
//# sourceMappingURL=logs.js.map
